import { useNavigate, useSearchParams } from "react-router-dom";
import { useCreateObservationForm } from "src/features/observationsAdmin/hooks";
import { CreateNewObservationForm } from "src/features/observationsAdmin/components/CreateNewObservationForm";
import { Schema } from "src/features/observationsAdmin/components/CreateNewObservationForm/schema";

interface NewObservationFormProps {}

const NewObservationForm = () => {
	const navigate = useNavigate();
	const { mutate: createObservationForm } = useCreateObservationForm();

	const [searchParams] = useSearchParams();
	const categoryId = searchParams.get("categoryId") || "";

	const defaultValues: Schema = {
		observationType: "",
		category: parseInt(categoryId) || undefined,
		formName: "",
		sendEmail: true,
		observationRecipients: [],
		gradingRecipients: [],
		observationSpecificEmailAddress: "",
		gradingSpecificEmailAddress: "",
		customEmail: false,
		customEmailBody: "",
		customEmailSubject: "",
		customEmailTitle: "",
		limitToCurrentUser: false
	};

	const onSuccess = (form: IAdminObservationForm) => {
		navigate(`/observations/forms/${form.id}/questions/`, {
			state: {
				observationFormId: form.id
			}
		});
	};

	const handleOnValid = (data: Schema) => {
		// Since validation schema is not same as endpoint add check
		if (!data.observationType) return;

		createObservationForm(
			{
				name: data.formName,
				category: data.category,
				observation_type: data.observationType,
				send_email: data.sendEmail,
				grading_recipients: data.gradingRecipients,
				grading_specific_email_address: data.gradingSpecificEmailAddress,
				observation_recipients: data.observationRecipients,
				observation_specific_email_address:
					data.observationSpecificEmailAddress,
				custom_email: data.customEmail,
				custom_email_body: data.customEmailBody,
				custom_email_subject: data.customEmailSubject,
				custom_email_title: data.customEmailTitle,
				draft: true,
				published: false,
				archived: false,
				limit_to_current_user: data.limitToCurrentUser
			},
			{ onSuccess }
		);
	};

	return (
		<CreateNewObservationForm
			defaultValues={defaultValues}
			onValid={handleOnValid}
		/>
	);
};

export { NewObservationForm, type NewObservationFormProps };
